import { render } from "./ProfilesEdit.vue?vue&type=template&id=8f91cb7c"
import script from "./ProfilesEdit.vue?vue&type=script&lang=js"
export * from "./ProfilesEdit.vue?vue&type=script&lang=js"

import "./ProfilesEdit.vue?vue&type=style&index=0&id=8f91cb7c&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__